import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import PageHero from "@/components/site/PageHero";

const PHOTOS = [
  {
    src: "https://customer-assets.emergentagent.com/job_forestry-mulch-pro/artifacts/2zwv29zz_20230829_172347.JPG",
    title: "Brush Mulching",
    caption: "Reclaiming overgrown pasture with our Takeuchi track loader and Kubota cutter.",
    span: "lg:col-span-2 lg:row-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forestry-mulch-pro/artifacts/n1hyddka_20231103_153659.JPG",
    title: "Property Reclamation",
    caption: "Cleared and graded around an existing structure — ready to use again.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forestry-mulch-pro/artifacts/y9hsvl8t_20231103_154210.JPG",
    title: "Forestry Mulching",
    caption: "Cutting through heavy underbrush in a single pass.",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forestry-mulch-pro/artifacts/g2ezp32j_20231103_170837.JPG",
    title: "Driveway & Access Prep",
    caption: "Path cleared through dense vegetation — opening up the property again.",
    span: "lg:col-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forestry-mulch-pro/artifacts/gyz0s9o8_20250905_153201.JPG",
    title: "Lot Clearing",
    caption: "Residential lot cleared with our Bobcat T190 — ready for what's next.",
    span: "lg:col-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forestry-mulch-pro/artifacts/pgqmxi36_5583.JPG",
    title: "Stump Removal",
    caption: "Pulling a large stump on a residential lot with our Takeuchi TB260 excavator.",
    span: "lg:col-span-2",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_forestry-mulch-pro/artifacts/41esnted_Snapchat-1318820689.JPG",
    title: "Demolition Cleanup",
    caption: "Bobcat T190 with grapple rake clearing demolition debris from a site.",
    span: "lg:col-span-4",
  },
];

export default function Gallery() {
  return (
    <div data-testid="gallery-page">
      <PageHero
        eyebrow="Field Work"
        title="Real machines. Real properties. Real results."
      />

      <section className="bg-[#F9F8F6] py-16 md:py-24">
        <div className="mx-auto max-w-7xl px-6 md:px-12">
          <div className="grid grid-cols-1 gap-4 sm:grid-cols-2 lg:auto-rows-[260px] lg:grid-cols-4">
            {PHOTOS.map((p, i) => (
              <figure
                key={i}
                data-testid={`gallery-item-${i}`}
                className={`group relative overflow-hidden border border-[#D1CCC5] bg-[#E8E2DA] ${p.span || ""}`}
              >
                <img
                  src={p.src}
                  alt={p.title}
                  className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105"
                  loading="lazy"
                />
              </figure>
            ))}
          </div>

          <div className="mt-16 flex justify-end border-t border-[#D1CCC5] pt-12">
            <Link
              to="/contact"
              data-testid="gallery-cta"
              className="inline-flex items-center gap-2 bg-[#D95D39] px-7 py-4 text-sm font-bold uppercase tracking-wider text-white transition-colors hover:bg-[#B94B2C]"
            >
              Request a Quote <ArrowRight size={16} strokeWidth={2.5} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
}
